module.exports = __webpack_public_path__ + "static/6-f7419c542deb882c2e50f5ae14f9a718.svg";